"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectView = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var defaultWrapper = function defaultWrapper(background, color) {
  return "\n  background-color: ".concat(background ? background : "rgba(0, 0, 0, 0.04)", ";\n  padding: 8px 15px 0px;\n  margin-bottom: 10px;\n  border-bottom: 1px solid ").concat(color, ";\n  border-radius: 4px 4px 0 0;\n  box-sizing: border-box;\n");
};

var nakedWrapper = function nakedWrapper() {
  return "\n  background-color: none;\n  padding: 8px 15px 0px;\n  margin-bottom: 10px;\n  border-radius: 4px 4px 0 0;\n  box-sizing: border-box;\n";
};

var SelectView = _styled.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n\n  &:focus-within {\n    background: rgba(0, 0, 0, 0.05);\n  }\n\n  .select-wrapper {\n    display: block;\n    margin-bottom: 0;\n  }\n\n  .select-label {\n    font-size: 12px;\n    color: ", ";\n    letter-spacing: 0.4px;\n  }\n\n  .select {\n    border-color: #f3f6f9;\n    color: #464e5f;\n    transition: color 0.15s ease, background-color 0.15s ease,\n      border-color 0.15s ease, box-shadow 0.15s ease;\n    width: 100%;\n\n    & .MuiSelect-select:focus {\n      background-color: rgba(0, 0, 0, 0);\n    }\n    & .MuiSelect-icon {\n      color: ", " !important;\n    }\n  }\n\n  .form-grp {\n    margin-bottom: 1.75rem;\n  }\n\n  .error {\n    color: \"red\";\n  }\n\n  .tip {\n    color: \"rgba(0, 0, 0, 0.6)\";\n  }\n"])), function (_ref) {
  var background = _ref.background,
      color = _ref.color,
      variant = _ref.variant;
  return variant === "naked" ? nakedWrapper() : defaultWrapper(background, color);
}, function (_ref2) {
  var color = _ref2.color;
  return color;
}, function (_ref3) {
  var color = _ref3.color;
  return color;
});

exports.SelectView = SelectView;

//# sourceMappingURL=Select.style.js.map